// DETAILS PAGE NAVIGATION, ELEMENT IDS

// https://stackoverflow.com/a/52396706
const mirror = <V extends keyof any>(v: V) => v;

/**
 * @Note
 * this file was primarily meant to act as static values needed for
 * details navigation and filter screen names because of which see the comments below
 * -------------------------------------------------------------------------------------
 * @TODO
 * This can be changed to a better code with being less verbose after upgarding to TS 4.1+
 * Also Please Add the tabs in order
 */
export const dayUseNavigationMenuNames = {
  autosuggest: mirror('dayuse-autosuggest'),
  calendar: mirror('dayuse-calendar'),
  checkinTime: mirror('dayuse-checkintime'),
  home: mirror('dayuse-home'),
  srp: mirror('dayuse-srp'),
  goSuggest: mirror('dayuse-gosuggest'),
  detail: mirror('dayuse-detail'),
  amenities: mirror('dayuse-amenitiesFilter'),
  locationFilter: mirror('dayuse-locationFilter'),
  gallery: mirror('dayuse-gallery'),
  seosrp: mirror('dayuse-seosrp'),
};

// @Note DayUseNavigationIdsMweb are same as first level dayUseDetailsNavigationIdsAndValues
// object's value for consistency and to make parity with existing flow
export enum DayUseNavigationIdsMweb {
  overview = 'overview',
  amenities = 'amenities',
  reviews = 'reviews',
  maps = 'maps',
  location = 'location',
  hotelPolicies = 'hotelPolicies',
  policies = 'policies',
  travelDetails = 'travelDetails',
}

// code to be uncommented and replaced with object counter part when upgarded to prettier above 2.2.1
// (husky won't pass it due lower prettier version not supporting template string)
// export enum DetailsNavigationMenuNames {
//   overview = 'Overview',
//   amenities = 'Amenities',
//   guestReviews = 'Guest Reviews',
//   location = 'Location',
//   policiesRules = 'Policies & Rules',
//   maps = 'maps',
// }

// export type DetailsNavigationMenuNamesType = `${DetailsNavigationMenuNames}`;

export const DetailsNavigationMenuNames = {
  overview: mirror('Overview'),
  amenities: mirror('Amenities'),
  policiesRules: mirror('Policies & Rules'),
  guestReviews: mirror('Ratings & Reviews'),
  location: mirror('Location'),
  maps: mirror('maps'),
  travelDetails: mirror('Travel Details'),
  reviews: mirror('Reviews'),
  policies: mirror('Policies'),
};

export type DetailsNavigationMenuNamesType = typeof DetailsNavigationMenuNames[keyof typeof DetailsNavigationMenuNames];

export const dayUseDetailsRouteToScreenMap = {
  [DetailsNavigationMenuNames.amenities]: DayUseNavigationIdsMweb.amenities,
  [DetailsNavigationMenuNames.guestReviews]: DayUseNavigationIdsMweb.reviews,
  [DetailsNavigationMenuNames.policiesRules]: DayUseNavigationIdsMweb.hotelPolicies,
  [DetailsNavigationMenuNames.policies]: DayUseNavigationIdsMweb.policies,
  [DetailsNavigationMenuNames.reviews]: DayUseNavigationIdsMweb.reviews,
  [DetailsNavigationMenuNames.overview]: DayUseNavigationIdsMweb.overview,
  [DetailsNavigationMenuNames.maps]: DayUseNavigationIdsMweb.maps,
  [DetailsNavigationMenuNames.location]: DayUseNavigationIdsMweb.location,
  [DetailsNavigationMenuNames.travelDetails]: DayUseNavigationIdsMweb.travelDetails,
};

export const dayUseDetailsNavigationIdsAndValues = {
  overview: {
    id: '#overview-dayuse',
    value: DetailsNavigationMenuNames.overview,
  },
  amenities: {
    id: '#amenities-dayuse',
    value: DetailsNavigationMenuNames.amenities,
  },
  hotelPolicies: {
    id: '#hotel-policies-dayuse',
    value: DetailsNavigationMenuNames.policiesRules,
  },
  reviews: {
    id: '#guest-reviews-dayuse',
    value: DetailsNavigationMenuNames.guestReviews,
  },
  location: {
    id: '#location-dayuse',
    value: DetailsNavigationMenuNames.location,
  },
  travelDetails: {
    id: '#traveldetails-dayuse',
    value: DetailsNavigationMenuNames.travelDetails,
  },
};

type DayUseDetailsNavigationIdsType = {
  [K in keyof typeof dayUseDetailsNavigationIdsAndValues]: string;
};

export const dayUseDetailsNavigationIds = Object.keys(dayUseDetailsNavigationIdsAndValues).reduce(
  (idsAccumulator, currentKey) => {
    return {
      ...idsAccumulator,
      [currentKey]: dayUseDetailsNavigationIdsAndValues[currentKey].id.replace('#', ''),
    };
  },
  {} as DayUseDetailsNavigationIdsType,
);
